<template>
  <div>
    <div class="columns">
      <div class="column">
        <span><b>Nacimiento</b></span>
        <p><b-icon icon="calendar" size="is-small"></b-icon> {{ birthDate }}</p>
      </div>
      <div class="column">
        <span><b>Edad</b></span>
        <p>{{ age }}</p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <span><b>Padre</b></span>
        <p><b-icon icon="gender-male" type="is-info" size="is-small"></b-icon> {{father}}</p>
      </div>
      <div class="column">
        <span><b>Madre</b></span>
        <p><b-icon icon="gender-female" type="is-danger" size="is-small"></b-icon> {{mother}}</p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <span><b>Color</b></span>
        <p>{{ color }}</p>
      </div>
      <div class="column">
        <span><b>Género</b></span>
        <p><b-icon :icon="genderIcon" :type=" horse.gender === 'M' ? 'is-info' : 'is-danger'" size="is-small"></b-icon> {{gender}}</p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <span><b>Estado</b></span>
        <p><status-horse :status="this.horse.active" /></p>
      </div>
    </div>
    <!-- <div class="columns">
      <div class="column">
        <h6 class="title is-6">Ubicación</h6>
        <h6 class="subtitle is-6"><b-icon icon="map-marker" size="is-small"></b-icon> </h6>
      </div>
    </div> -->
    <!-- <div class="columns">
      <div class="column">
        <h6 class="title is-6">Jinete Actual</h6>
        <h5 class="subtitle is-5"><b-icon icon="account-circle" size="is-small"></b-icon> {{rider}}</h5>
      </div>
    </div> -->
  </div>
</template>

<script>
import StatusHorse from '@/components/StatusHorse'
export default {
  components: {
    StatusHorse
  },
  props: {
    horse: {
      required: true,
      type: Object
    }
  },
  data () {
    return {

    }
  },
  computed: {
    birthDate () {
      return this.horse.birth_date ? this.moment(this.horse.birth_date, 'YYYY-MM-DD').format('L') : 'S/I'
    },
    age () {
      return this.horse.age ? `${this.horse.age.years}-${this.horse.age.months}` : 'S/I'
    },
    father () {
      return this.horse.father ? this.horse.father.name : 'S/I'
    },
    mother () {
      return this.horse.mother ? this.horse.mother.name : 'S/I'
    },
    color () {
      return this.horse.color ? this.horse.color : 'S/I'
    },
    rider () {
      return this.horse.rider ? `${this.horse.rider.lastname}-${this.horse.rider.name}` : 'S/I'
    },
    genderIcon () {
      let icon = ''
      if (this.horse.gender === 'M') {
        icon = 'gender-male'
      } else if (this.horse.gender === 'F') {
        icon = 'gender-female'
      }
      return icon
    },
    gender () {
      let gender = this.noInfo
      if (this.horse.gender === 'M') {
        gender = 'Macho'
      } else if (this.horse.gender === 'F') {
        gender = 'Hembra'
      }
      return gender
    }
  }
}
</script>
